export default {
  additionalInformation: 'Informations supplémentaires',
  requiredFields: 'Champs obligatoires',
  optionalFields: 'Champs optionnels',
  loadError: 'Erreur de chargement des champs dynamiques',

  // Field type labels (fallback if not in definition)
  fieldTypes: {
    string: 'Texte',
    integer: 'Nombre entier',
    float: 'Nombre décimal',
    boolean: 'Oui/Non',
    select: 'Sélection'
  },

  // Context labels
  contexts: {
    reservation: 'Réservation',
    borrowing: 'Retrait/Emprunt',
    return: 'Retour'
  },

  // Validation messages
  validation: {
    required: 'Ce champ est obligatoire',
    minLength: 'La longueur minimale est de {min} caractères',
    maxLength: 'La longueur maximale est de {max} caractères',
    min: 'La valeur minimale est {min}',
    max: 'La valeur maximale est {max}',
    pattern: 'Format invalide',
    invalidType: 'Type de valeur invalide'
  },

  // Manager UI
  manager: {
    title: 'Champs dynamiques d\'emprunt',
    description: 'Configurez les champs dynamiques qui seront demandés lors de la réservation, l\'emprunt ou le retour des ressources dans cette catégorie.',
    addField: 'Ajouter un champ',
    newField: 'Nouveau champ',
    fieldKey: 'Clé du champ',
    keyHelp: 'Identifiant unique (minuscules, sans espaces)',
    fieldType: 'Type',
    label: 'Libellé',
    labelPlaceholder: 'Libellé affiché aux utilisateurs',
    helpText: 'Texte d\'aide',
    helpTextPlaceholder: 'Texte d\'aide optionnel',
    placeholder: 'Placeholder',
    placeholderExample: 'ex: 50000',
    required: 'Champ obligatoire',
    descriptionField: 'Afficher comme description dans la carte d\'emprunt',
    contexts: 'Quand demander ce champ',
    contextsHelp: 'Sélectionner un ou plusieurs',
    allContexts: 'Tous',
    options: 'Options',
    addOption: 'Ajouter une option...',
    noFields: 'Aucun champ dynamique configuré.',
    keyAndLabelRequired: 'La clé et le libellé du champ sont requis',
    keyAlreadyExists: 'Un champ avec cette clé existe déjà',
    selectNeedsOptions: 'Un champ de sélection doit avoir au moins une option',
    optionAlreadyExists: 'Cette option existe déjà',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce champ ?',
    dragHint: 'Glissez-déposez les champs pour changer leur ordre d\'affichage',
    editField: 'Modifier le champ',
    keyCannotChange: 'La clé du champ ne peut pas être modifiée',
    labelRequired: 'Le libellé est requis'
  }
};
